import { DefaultFiltersType } from "../types";
import { useEffect, useState } from "react";
import { useDocumentList } from "../../document-page/state/useDocumentList";

export const useFilters = (
  defaultFilters?: DefaultFiltersType
): [
  DefaultFiltersType,
  React.Dispatch<React.SetStateAction<DefaultFiltersType>>,
  (name: keyof DefaultFiltersType, value: any) => void
] => {
  const { filterSettings, setFilterSetting, setIsFiltering } =
    useDocumentList();
  const savedFiltersRaw = localStorage.getItem("filters");
  let savedFilters: DefaultFiltersType = JSON.parse(savedFiltersRaw ?? "{}");

  const { setOnFilterChange, onFilterChange, onScroll } = useDocumentList();
  if (Object.keys(savedFilters).length === 0 && defaultFilters) {
    savedFilters = defaultFilters;
  }

  const [filters, setFilters] = useState<DefaultFiltersType>(savedFilters);
  ///// Remove this comment after we see stable version of filters

  // useEffect(() => {
  //   localStorage.setItem("filters", JSON.stringify(filters));
  // }, [filters]);

  const handleFilterChange = (name: keyof DefaultFiltersType, value: any) => {
    setFilterSetting(name, value);
    //   setFilters((prevFilters) => {
    //     if (JSON.stringify(savedFilters) !== JSON.stringify(prevFilters)) {
    //       setOnFilterChange(true);
    //     }

    //     return {
    //       ...prevFilters,
    //       [name]: value,
    //     };
    //   }
    // );
  };
  return [filterSettings, setFilters, handleFilterChange];
};
